<template>
  <validation-observer v-slot="{ handleSubmit }">
    <div class="row">
      <div class="col-md-12 text-bold bold mb-3">
        <i class="fa fa-redo-alt color-orange" />
        Recibida de SAEE
      </div>
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            v-model="model.receptionDate"
            class-container="w-100"
            custom-error-msg="Favor seleccione la fecha de recepción."
            :error="errors[0]"
            label="Fecha:"
            :max-date="new Date()"
            :min-date="beforeBankRequestDate"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="receptionTypeSelected"
            :clearable="false"
            custom-error-msg="Favor seleccionar qué se recibió."
            :disabled="receptionTypeDisabled"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="¿Qué se recibió?"
            :options="receptionTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="col-md-12 mt-2">
        <custom-text-area
          v-model="model.comment"
          label="Comentario:"
          :maxlength="500"
          :rows="4"
          show-char-count
        />
      </div>

      <div class="col-md-12 text-right mt-3 pt-1">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3"
          @click="$emit('on-cancel')"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success"
          @click="handleSubmit(submit)"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import CustomDatePicker from 'custom-date-picker';
import alertMixin from '@/mixins/alert.mixin';
import { putReceived as _putReceived } from '@/modules/shared/cardHandling.api';
import CustomDropDown from 'custom-drop-down';
import { getCardReceptionTypes as _getCardReceptionTypes } from '@/modules/shared/code.api.js';
import moment from 'moment';
export default {
  name: 'ReceivedCard',
  components: {
    CustomTextArea,
    CustomDatePicker,
    CustomDropDown,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    bankRequestDate: {
      type: Date,
      default: null,
    },
    claimByPin: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    model: {
      receptionTypeId: null,
      comment: null,
      receptionDate: null,
      becaCardId: null,
      claimByPin: false,
    },
    receptionTypeSelected: null,
    receptionTypes: [],
    receptionTypeDisabled: false,
  }),
  computed: {
    beforeBankRequestDate() {
      return moment(this.bankRequestDate)
        .subtract(1, 'days')
        .toDate();
    },
  },
  async mounted() {
    const { data } = await _getCardReceptionTypes();
    this.receptionTypes = data;

    if (this.claimByPin) {
      this.receptionTypeDisabled = true;
      this.receptionTypeSelected = this.receptionTypes[1];
    }
  },
  methods: {
    async submit() {
      this.model.becaCardId = this.id;
      this.model.receptionTypeId = this.receptionTypeSelected.id;
      this.model.claimByPin = this.claimByPin;
      await _putReceived(this.model)
        .then(() => {
          this.ShowToast(
            'Confirmación',
            'La recepción ha sido realizada exitosamente.',
            'success'
          );
          this.$emit('on-saved');
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
  },
};
</script>
<style scoped lang="scss"></style>
